module.exports = __webpack_public_path__ + "static/media/volumeTwo02.d6b90ecc.jpg";